import { mapGetters } from 'vuex';

export default {
    computed: mapGetters({
        permissions: 'auth/permissions',
    }),
    methods: {
        can(permissionName) {
            const permisos = this.permissions;
            const hasAccess = permisos.filter((permiso) => permiso.name === permissionName);
            if (hasAccess.length > 0) {
                return true;
            }
            return false;
        },
    },
};
